<template>
  <LinkButton
    :tag="emitOnlyClick ? 'button' : 'nuxt-link'"
    :primary="active"
    :transparent="!active"
    :to="emitOnlyClick ? undefined : url"
    small-padding
    class="pagination-link"
    @click="emitClick"
  >
    {{ page }}
  </LinkButton>
</template>

<script>
import { LinkButton } from '@i22-td-smarthome/component-library';

export default {
  name: 'PaginationLink',
  components: { LinkButton },
  props: {
    page: {
      type: Number,
      required: true,
    },
    url: {
      type: [Object, String, Number],
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  methods: {
    emitClick() {
      this.$emit('click', this.url);
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.pagination-link {
}
</style>
